var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceCardTracery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 181,
    viewBox: "0 0 294 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-128.464 172.336C-151.884 154.952 -167.073 127.021 -167.073 95.6137C-167.073 42.7654 -124.29 0 -71.4203 0C-24.4638 0 14.7246 33.9573 22.7246 78.5771",
    stroke: "currentColor",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94202 153.677C11.2464 135.25 29.2174 122.27 50.3188 122.27C62.9565 122.27 74.5507 127.021 83.3623 134.786C87.7681 138.727 91.4782 143.363 94.3768 148.578C98.0869 155.648 100.29 163.644 100.29 172.105C100.29 173.843 100.174 175.697 100.058 177.436",
    stroke: "currentColor",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-44.6377 149.621C-34.6667 106.74 3.71012 74.7526 49.7391 74.7526C83.826 74.7526 113.855 92.3687 131.014 119.025C137.391 118.097 143.884 117.634 150.609 117.634C228.406 117.634 291.478 180.681 291.478 258.447C291.478 336.097 228.638 399.028 151.072 399.26",
    stroke: "currentColor",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2609 187.635C103.304 172.221 125.797 162.833 150.609 162.833C203.478 162.833 246.261 205.598 246.261 258.447C246.261 308.629 207.652 349.772 158.493 353.713",
    stroke: "currentColor",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.638 223.446C144 222.519 147.478 221.94 151.188 221.94C171.71 221.94 188.29 238.513 188.29 259.026C188.29 279.076 172.406 295.301 152.58 296.113V295.997C156.638 311.643 158.725 327.984 158.725 344.789C158.725 452.687 71.3043 540.072 -36.6377 540.072C-144.58 540.072 -232 452.687 -232 344.789C-232 236.89 -144.58 149.505 -36.6377 149.505C6.02898 149.505 45.5652 163.181 77.6812 186.36",
    stroke: "currentColor",
    strokeWidth: 13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.246 381.759C221.333 379.326 274.087 325.087 274.087 258.447C274.087 190.3 218.783 135.018 150.609 135.018C146.899 135.018 143.188 135.134 139.594 135.482C133.217 136.061 126.841 137.104 120.696 138.611C118.145 133.048 114.899 127.948 111.188 123.197C96.9275 105.001 74.6667 93.2958 49.6232 93.2958C13.9131 93.2958 -16.2319 117.17 -25.6232 149.853",
    stroke: "currentColor",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCardTracery);
export default __webpack_public_path__ + "static/media/serviceCardTracery.123c712e8c9ad96936d77c32e81bc25f8fd36ed0cc714896cbe15e78d6f79747.svg";
export { ForwardRef as ReactComponent };